import angular from "angular";
import { DashboardModifiedTimeEntriesContainerComponent } from "./modified-time-entries-container.component";
import { DashboardTimeEntryModificationsContainerComponent } from "./time-entry-modifications-container.component";
import { DashboardModifiedTimeEntriesComponent } from "./modified-time-entries.component";
import { DashboardTimeEntryModificationsComponent } from "./time-entry-modifications.component";
import { dashboardModifiedTimeEntriesItemTemplate, dashboardModifiedTimeEntriesListItemTemplate } from './dashboard-modified-time-entries.block'
import { dashboardTimeEntryModificationsItemTemplate, dashboardTimeEntryModificationsListItemTemplate } from './dashboard-time-entry-modifications-templates.block'

export const TimeEntryDashboardModule = angular
    .module("apex.mainApp.timeEntry.dashboard", [])
    .component("apexDashboardModifiedTimeEntriesContainer", DashboardModifiedTimeEntriesContainerComponent)
    .component("apexDashboardTimeEntryModificationsContainer", DashboardTimeEntryModificationsContainerComponent)
    .component("apexDashboardModifiedTimeEntries", DashboardModifiedTimeEntriesComponent)
    .component("apexDashboardTimeEntryModifications", DashboardTimeEntryModificationsComponent)
    .run(dashboardModifiedTimeEntriesItemTemplate)
    .run(dashboardModifiedTimeEntriesListItemTemplate)
    .run(dashboardTimeEntryModificationsItemTemplate)
    .run(dashboardTimeEntryModificationsListItemTemplate)
    .name
